import { useDispatch, useSelector } from 'react-redux'
import { clearError, fetchCategories } from '../store/slices/categoriesSlice'
import { AppDispatch, RootState } from '../store/store'

export const useCategoriesRedux = () => {
  const dispatch = useDispatch<AppDispatch>()
  const { categories, loading, error } = useSelector((state: RootState) => state.categories)

  const fetchCategoriesData = (params?: { limit?: number; offset?: number }) => {
    dispatch(fetchCategories(params))
  }

  const clearCategoriesError = () => {
    dispatch(clearError())
  }

  // Прості функції, які працюють з поточним станом
  const getCategoryByInternalName = (internalName: string) => {
    return categories.find(category => category.internalName === internalName)
  }

  const getCategoryByExternalName = (externalName: string) => {
    return categories.find(category => category.externalName === externalName)
  }

  return {
    categories,
    loading,
    error,
    fetchCategories: fetchCategoriesData,
    clearError: clearCategoriesError,
    getCategoryByInternalName,
    getCategoryByExternalName,
  }
}
